import { ArrowRight } from '@mui/icons-material';
import { Badge, Box, Fab, Slide, Tab, Tabs, styled, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import useSocket from '../../_hooks/Socket';
import { ALL_PACKAGES, MAX_GLOBAL_DATA, SUCCESS } from '../../constants';
import { GlobalAlerts, WS_ALERTS } from '../../services/ApiEndpoints';
import ApiService from '../../services/ApiService';
import Scrollbar from '../Scrollbar';
import { TabPanel, a11yProps } from '../tabs';
import styles from './Alerts.module.scss';
import GlobalAlertsData from './GlobalAlerts';
import GlobalTicketsData from './GlobalTickets';

// ----------------------------------------------------------------------

const RootStyleMain = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    // width: `${toggle ? '296px' : 'maxWidth'}`
    width: 'maxWidth'
  }
}));

const GloabalAlertListing = ({ slideOpen, setSlideOpen, setAlertsInfo }) => {
  const { apiService } = ApiService();
  const allPackage = JSON.parse(localStorage.getItem(ALL_PACKAGES));
  const { palette, CommonPalette } = useTheme();
  const [totalAlerts, setTotalAlert] = useState(0);
  const [totalTicket, setTotalTicket] = useState();
  const [value, setValue] = useState(0);
  const [tickets, setTickets] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const { lastMessage } = useSocket(WS_ALERTS);
  const [loading, setLoading] = useState(false);
  const [newAlerts, setNewAlerts] = useState(0);

  useEffect(() => {
    if (lastMessage !== null) {
      const allowedPackage = JSON.parse(localStorage.getItem('allPackages'));

      const { data } = JSON.parse(lastMessage.data);

      if (alerts?.length > MAX_GLOBAL_DATA) {
        alerts.pop();
      }
      if (allowedPackage.includes(data.package_id)) {
        setAlerts((prev) => [{ ...data, isNew: true }, ...prev]);
        setTotalAlert((prev) => prev + 1);
        setNewAlerts((prev) => prev + 1);
      }
    }
  }, [lastMessage]);

  const getGlobalAlerts = () => {
    setLoading(true);
    apiService(
      { url: GlobalAlerts, method: 'post', data: { package_ids: allPackage } },
      { loader: false }
    )
      .then((result) => {
        if (result?.status === SUCCESS) {
          const _data = result.data;

          setTotalAlert(_data.total_alert);
          setAlerts(_data.listing);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setAlertData(alerts);
    setAlertsInfo((prev) => ({
      ...prev,
      totalAlert: totalAlerts,
      onClick: () => setSlideOpen((prev) => !prev)
    }));
  }, [alerts]);

  useEffect(() => {
    setAlertsInfo((prev) => ({
      ...prev,
      newAlerts
    }));
  }, [newAlerts]);

  const handleGlobalAlertFilter = (e) => {
    setGlobalFilterValue(e.target.value);
    if (e.target.value === '' || e.target.value === '#') {
      setAlerts(alertData);
    } else if (e.target.value.startsWith('#')) {
      const filterData = alerts.filter((row) =>
        row.id.toString().toLowerCase().includes(e.target.value.slice(1).toLowerCase())
      );
      setAlerts(filterData);
    }
  };

  const markAlertRead = (alertInfo) => {
    setAlerts(alerts.map((item) => (item.id === alertInfo.id ? { ...item, isNew: false } : item)));
    if (alertInfo?.isNew) setNewAlerts((prev) => prev - 1);
  };

  useEffect(() => {
    getGlobalAlerts();
  }, []);
  const handleCheckChange = () => {
    setSlideOpen((prev) => !prev);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <RootStyleMain>
      <Box style={{ position: 'fixed', right: '0px', zIndex: '9' }}>
        <Fab
          sx={{
            left: '-25px',
            background: CommonPalette.lightpink,
            display: slideOpen ? 'show' : 'none',
            borderBottom: '1px solid #dee2e6 !important',
            borderLeft: '1px solid #dee2e6 !important',
            height: '32px',
            zIndex: 22,
            width: '30px',
            borderRadius: '5px 0px 0px 5px',
            position: 'absolute',
            boxShadow: 'none'
          }}
          onClick={handleCheckChange}
          size="small"
        >
          <ArrowRight sx={{ fontSize: '25px !important' }} />
        </Fab>

        <Slide
          direction="left"
          in={slideOpen}
          mountOnEnter
          unmountOnExit
          sx={{
            background: palette.background.main,
            boxShadow: '-10px 0px 20px rgb(0 0 0 / 25%)'
          }}
        >
          <Box className="global-alert-container">
            <Scrollbar
              sx={{
                height: '100%',
                '& .simplebar-content': {
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }
              }}
            >
              <Box sx={{ borderRadius: '10px' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="fullWidth"
                  scrollButtons={false}
                  aria-label="scrollable prevent tabs example"
                >
                  <Tab
                    className={styles.tab_title_button}
                    icon={
                      <Badge
                        className="badge-icon"
                        badgeContent={totalAlerts}
                        color="error"
                        max={totalAlerts + 1}
                      />
                    }
                    label="Alerts"
                    {...a11yProps(0)}
                  />
                </Tabs>
              </Box>

              <TabPanel value={value} index={0}>
                <GlobalAlertsData
                  markAlertRead={markAlertRead}
                  alertInfo={alerts}
                  globalFilterValue={globalFilterValue}
                  loading={loading}
                  handleGlobalAlertFilter={handleGlobalAlertFilter}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <GlobalTicketsData tickets={tickets} />
              </TabPanel>
            </Scrollbar>
          </Box>
        </Slide>
      </Box>
    </RootStyleMain>
  );
};

export default GloabalAlertListing;
